export default "__VITE_ASSET__BTwW85nm__"